module.exports = __webpack_public_path__ + "static/media/Negative.684ee9f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pc/Negative.svg
// module id = 311
// module chunks = 0